import { useState } from 'react'
import { Link as RouterLink } from 'react-router-dom'
import PropTypes from 'prop-types'
import MenuIcon from '@mui/icons-material/Menu'
import Brand from '../brand'
import MobileNavigation from './mobile-navigation'
import { Ribbon } from 'frame/components'
/**
 * V5
 */
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import Toolbar from '@mui/material/Toolbar'

const TopBarMobile = ({ showAlfaOutageMessage, showIsPortalReadOnlyMessage, showMilesReliabilityWarningMessage, isOutOfHoursMessageDisabled, milesReliabilityWarningMessage }) => {
  const [open, setOpen] = useState(false)

  let warningRibbon = null
  if (showIsPortalReadOnlyMessage) {
    warningRibbon = <Ribbon text="READ-ONLY: Please note, the Fleet Portal is in read-only mode between the hours of 6pm and 6am." />
  } else if (showAlfaOutageMessage && !isOutOfHoursMessageDisabled) {
    warningRibbon = <Ribbon text="READ-ONLY: Please note, the ability to add/edit driver accounts and vehicle assignment is unavailable between the hours of 6pm and 6am." />
  }

  return (
    <Box backgroundColor='background.header' flexGrow={1}>
      <Toolbar
        position="static"
        sx={{
          flex: 1,
          minHeight: 74,
        }}>
        <RouterLink to="/" style={{ display: 'flex' }}>
          <Brand variant="light" />
        </RouterLink>
        <Box flex={1} />
        <Box
          display='flex'>
          <IconButton
            sx={{
              '& svg': {
                fill: 'white'
              }
            }}
            onClick={() => setOpen(true)}>
            <MenuIcon />
          </IconButton>
        </Box>
      </Toolbar>

      <MobileNavigation open={open} onClose={() => setOpen(false)} />

      {warningRibbon}
    </Box>
  )
}

TopBarMobile.propTypes = {
  showAlfaOutageMessage: PropTypes.bool,
  showIsPortalReadOnlyMessage: PropTypes.bool,
}

export default TopBarMobile
